import {
	type GetDeviceByIdQuery,
	type GetDeviceDetailQuery,
	type GetDeviceFleetQuery,
	type GetDeviceFleetTelemetryLatestQuery,
	type GetDeviceLobbyQuery,
	type GetDeviceNetworkReportQuery,
	type GetDeviceProfileConfigKeysQuery,
	type GetDeviceTelemetryHistoryQuery,
	type GetDeviceTelemetryLatestForDeviceQuery,
	type GetDeviceWifiChangeStatusQuery
} from "~/gql/queries/devices.generated";

export const devicesEndpoints = {
	AssignDeviceLocation: {
		invalidatesTags: ["Devices"] as AddTagTypes
	},
	ClaimDevice: {
		invalidatesTags: ["Devices", "DeviceLobby"] as AddTagTypes
	},
	GetDeviceById: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceByIdQuery) => res
	},
	GetDeviceDetail: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceDetailQuery) => res
	},
	GetDeviceFleet: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceFleetQuery) => res
	},
	GetDeviceFleetTelemetryLatest: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceFleetTelemetryLatestQuery) => res
	},
	GetDeviceLobby: {
		providesTags: ["DeviceLobby"] as AddTagTypes,
		transformResponse: (res: GetDeviceLobbyQuery) => res
	},
	GetDeviceNetworkReport: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceNetworkReportQuery) => res
	},
	GetDeviceProfileConfigKeys: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceProfileConfigKeysQuery) => res
	},
	GetDeviceTelemetryHistory: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceTelemetryHistoryQuery) => res
	},
	GetDeviceTelemetryLatestForDevice: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceTelemetryLatestForDeviceQuery) => res
	},
	GetDeviceWifiChangeStatus: {
		providesTags: ["Devices"] as AddTagTypes,
		transformResponse: (res: GetDeviceWifiChangeStatusQuery) => res
	},
	RenameDevice: {
		invalidatesTags: ["Devices"] as AddTagTypes
	},
	RevokeDeviceCredential: {
		invalidatesTags: ["Devices"] as AddTagTypes
	},
	SendDeviceCommand: {
		invalidatesTags: ["Devices"] as AddTagTypes
	},
	SetDeviceDesiredConfig: {
		invalidatesTags: ["Devices"] as AddTagTypes
	}
};
